module.exports = "<md-sidenav-container>\n  <router-outlet></router-outlet>\n</md-sidenav-container>"


//////////////////
// WEBPACK FOOTER
// /Volumes/MACOS-START/Outside/SITE Co-WORKING/ng/src/app/layouts/auth/auth-layout.component.html
// module id = ../../../../../src/app/layouts/auth/auth-layout.component.html
// module chunks = 8